import React, { useEffect } from 'react';
import Styles from './styles';
import { Spin } from 'antd';
import { ResultItem } from './ResultItem/ResultItem';
import { ProviderIntegration } from '../../../../../../../redux/typings/store';
import { Empty } from 'antd';

const { Container, ResultContainer, SpinnerContainer } = Styles;

interface Props {
  accounts: ProviderIntegration[];
  loading: boolean;
  onSelect: (value: ProviderIntegration) => void;
  selected: ProviderIntegration | null;
  setSelected: (ev: ProviderIntegration | null) => unknown;
}

const Results: React.FC<Props> = ({ accounts, loading, onSelect, selected, setSelected }) => {
  useEffect(() => {
    setSelected(null);
  }, [loading]);

  return (
    <Container>
      {loading ? (
        <SpinnerContainer>
          <Spin />
        </SpinnerContainer>
      ) : (
        <ResultContainer>
          {accounts.map(acc => (
            <ResultItem
              key={acc.id}
              onClick={() => {
                onSelect(acc);
                setSelected(acc);
              }}
              name={acc.name}
              provider={acc.provider}
              selected={acc.id === selected?.id}
            />
          ))}

          {accounts.length === 0 && (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No CRM accounts found" />
          )}
        </ResultContainer>
      )}
    </Container>
  );
};

export { Results };
